<template>
  <a
    :href="$stores.appData?.state?.data?.general?.whatsappAssistanceLink"
    target="_blank"
    class="fixed bottom-36 right-4 z-50 w-16 h-16 bg-green-500 rounded-full flex items-center justify-center shadow-lg hover:scale-110 active:scale-95 transition-transform duration-200"
  >
    <div class="w-8 h-8">
      <ColorImg
        src="/images/icons/whatsapp.svg"
        fallback="/images/icons/chat.svg"
        class="w-full h-full bg-white"
        alt="WhatsApp"
      />
    </div>
  </a>
</template>
